var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.innerDrawer)?_c('Editor',{attrs:{"apiKey":"0g85j0efm0dz98h4le3448md0ug2fvfs7b9r60hj0udoz8bb","id":_vm.tinymceId,"init":_vm.init,"disabled":_vm.disabled}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }